import { LinkType } from '../../../core/types';
export const emptyLink = {
    href: '',
    text: '',
    anchor: '',
    linktype: LinkType.INTERNAL,
    class: '',
    title: '',
    querystring: '',
    id: '',
    target: undefined,
};
const parseSitecoreLink = (link) => {
    if (!link)
        return emptyLink;
    const { href, text, linktype, querystring, class: linkClass, id, title, anchor, target } = link;
    return {
        href: href !== null && href !== void 0 ? href : '',
        text: text !== null && text !== void 0 ? text : '',
        anchor: anchor !== null && anchor !== void 0 ? anchor : '',
        class: linkClass !== null && linkClass !== void 0 ? linkClass : '',
        title: title !== null && title !== void 0 ? title : '',
        querystring: querystring !== null && querystring !== void 0 ? querystring : '',
        linktype: linktype !== null && linktype !== void 0 ? linktype : LinkType.INTERNAL,
        id: id !== null && id !== void 0 ? id : '',
        target: target !== null && target !== void 0 ? target : undefined,
    };
};
const parseNoOfferFields = (sitecoreFields) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    const fields = (_a = sitecoreFields === null || sitecoreFields === void 0 ? void 0 : sitecoreFields.data) === null || _a === void 0 ? void 0 : _a.value;
    if (!fields)
        return null;
    const image = (_c = (_b = fields.noOffersModalImage) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.value;
    return {
        title: (_e = (_d = fields.noOffersModalTitle) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '',
        bodyText: (_g = (_f = fields.noOffersModalDescription) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : '',
        image: {
            src: (_h = image === null || image === void 0 ? void 0 : image.src) !== null && _h !== void 0 ? _h : '',
            alt: (_j = image === null || image === void 0 ? void 0 : image.alt) !== null && _j !== void 0 ? _j : '',
            width: (_k = image === null || image === void 0 ? void 0 : image.width) !== null && _k !== void 0 ? _k : '',
            height: (_l = image === null || image === void 0 ? void 0 : image.height) !== null && _l !== void 0 ? _l : '',
        },
        ctas: [
            {
                link: parseSitecoreLink((_o = (_m = fields.noOffersModalCtaLink1) === null || _m === void 0 ? void 0 : _m.item) === null || _o === void 0 ? void 0 : _o.value),
                ctaType: ((_r = (_q = (_p = fields.noOffersModalCtaType1) === null || _p === void 0 ? void 0 : _p.value) === null || _q === void 0 ? void 0 : _q.toLowerCase()) !== null && _r !== void 0 ? _r : 'primary'),
                gtmInteractionType: (_t = (_s = fields.noOffersModalCtaGtmIntType1) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                gtmTitle: (_v = (_u = fields.noOffersModalCtaGtmTitle1) === null || _u === void 0 ? void 0 : _u.value) !== null && _v !== void 0 ? _v : '',
            },
            {
                link: parseSitecoreLink((_x = (_w = fields.noOffersModalCtaLink2) === null || _w === void 0 ? void 0 : _w.item) === null || _x === void 0 ? void 0 : _x.value),
                ctaType: ((_0 = (_z = (_y = fields.noOffersModalCtaType2) === null || _y === void 0 ? void 0 : _y.value) === null || _z === void 0 ? void 0 : _z.toLowerCase()) !== null && _0 !== void 0 ? _0 : 'secondary'),
                gtmInteractionType: (_2 = (_1 = fields.noOffersModalCtaGtmIntType2) === null || _1 === void 0 ? void 0 : _1.value) !== null && _2 !== void 0 ? _2 : '',
                gtmTitle: (_4 = (_3 = fields.noOffersModalCtaGtmTitle2) === null || _3 === void 0 ? void 0 : _3.value) !== null && _4 !== void 0 ? _4 : '',
            },
        ],
    };
};
export default parseNoOfferFields;
